import FJConstant from '../../../constants/FJConstant';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJFake3dEditContainer from './FJFake3dEdit/FJFake3dEditContainer';
import PropTypes from 'prop-types';
import FJFake3dExportContainer from './FJFake3dExport/FJFake3dExportContainer';

const FJFake3dLeft = props => {
    const { settingStep } = props;
    const render = () => {
        if (settingStep === FJConstant.DEFAULT) {
            return <FJFake3dEditContainer />;
        } else return <FJFake3dExportContainer />;
    };
    return <FJAppLeft>{render()}</FJAppLeft>;
};

FJFake3dLeft.propTypes = {
    settingStep: PropTypes.string,
};

export default FJFake3dLeft;
